<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-btn
            color="primary"
            class="mb-2"
            v-on:click="syncData"
            :disabled="loading"
          >
            <v-icon left>mdi-sync</v-icon>
            Đồng bộ
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    data: () => ({
      loading: false,
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Tên vật nuôi', value: 'ten' },
        { text: 'Loại', value: 'loaiDongVat.tenLoaiDongVat' },
        { text: 'Môi trường sống', value: 'moiTruongSong.tenMoiTruongSong' },
        { text: 'Ngày đồng bộ', value: 'createdAt' }
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      options: {},
    }),
    watch: {
      options: {
        handler() {
          this.initialize()
        },
      },
    },
    mounted () {
      // this.initialize();
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        const { page, itemsPerPage } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            datasync: true
          }
        };
        app.loading = true;
        axios.get("api/v1/public/get-animal-special-product", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      syncData(){
        const app = this;
        app.loading = true;
        axios.get("api/v1/sync-sp-channuoi")
          .then((response) => {
            app.initialize()
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            app.openSnackbar({ type: 'error' });
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>